<template>
    <v-layout style='flex: 0 0 auto !important;' column>
        <v-card tile flat>
            <v-list subheader expand class='mb-0 pb-0'>
                <v-list-item @click="visibility.create=true" v-if="wordstatplaceCreateAllowed">
                    <v-list-item-content class='pl-4'>
                        <v-list-item-title>Добавить фразу</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                        <v-icon>add</v-icon>
                    </v-list-item-action>
                </v-list-item>
                <template v-if='!wordstatplaces.length && !indicator.list'>
                    <v-list-item link>
                        <v-list-item-content class='pl-4'>
                            <v-list-item-title>Нет фраз</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-divider></v-divider>
                </template>
                <v-list-group
                        no-action
                        :value="true"
                        style='border-bottom: 1px solid;border-color:#EEEEEE;'
                        v-if="wordstatplaces.length"
                >
                    <template v-slot:activator>

                        <v-list-item style='background: transparent !important;'
                                     :two-line='!$vuetify.breakpoint.smAndUp' class='mx-0 px-0'>
                            <v-list-item-content>
                                <v-list-item-title>
                                    <v-layout row wrap mx-4>
                                        <span class='font-weight-medium'>Фразы</span>
                                    </v-layout>
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                    </template>


                    <v-list-item v-for='(s, si) in wordstatplaces' link class='pl-4'>
                        <v-list-item-action class='ml-4 mr-5'>
                            <span>{{ si+1 }}</span>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>
                                <span>Фразы: </span>
                                <v-chip
                                        class="ma-2"
                                        color="teal"
                                        text-color="white"
                                        v-for="phrase in s.phrases"
                                >
                                    <v-icon left>
                                        mdi-label
                                    </v-icon>
                                    <span>{{ phrase }}</span>
                                </v-chip>
                            </v-list-item-title>

                            <v-list-item-title>
                                <span>Регионы: </span>
                                <v-chip
                                        class="ma-2"
                                        color="teal"
                                        text-color="white"
                                        v-for="geo in s.geo_id"
                                >
                                    <span>{{ geo.region_name }}</span>
                                </v-chip>
                            </v-list-item-title>
                        </v-list-item-content>

                        <v-list-item-action title="Запустить скачивание" v-if="wordstatplaceDeleteAllowed">
                            <v-btn class='mr-1' icon @click.stop.prevent='downloadStat(s)'>
                                <v-icon color='green'>mdi-play</v-icon>
                            </v-btn>
                        </v-list-item-action>

                        <v-list-item-action v-if="wordstatplaceDeleteAllowed">
                            <v-btn class='mr-1' small icon
                                   @click.stop.prevent='castWordStatPlace(s); visibility.update = true;'>
                                <v-icon small color='light-blue darken-1'>mdi-square-edit-outline</v-icon>
                            </v-btn>
                        </v-list-item-action>

                        <v-list-item-action v-if="wordstatplaceDeleteAllowed">
                            <v-btn class='pa-0 ma-0' small icon
                                   @click.stop.prevent='castWordStatPlace(s); visibility.delete = true;'>
                                <v-icon small :color='$store.getters.uiAccentIcon'>delete_outline</v-icon>
                            </v-btn>
                        </v-list-item-action>

                    </v-list-item>
                </v-list-group>
            </v-list>
        </v-card>

        <wordstatplace-create :initialState.sync='visibility.create' :postAction='getProjectWordstatpalces'
                          :project='project'>

        </wordstatplace-create>
        <wordstatplace-update :initialState.sync='visibility.update' :postAction='getProjectWordstatpalces'
                          :wordstatplace='cursorWordstatplace'></wordstatplace-update>

        <wordstatplace-delete :initialState.sync='visibility.delete' :data='cursorWordstatplace'
                          :postAction='getProjectWordstatpalces' :projectId='project.project_id'></wordstatplace-delete>

    </v-layout>
</template>


<script>
    import CreateWordstatplace from '@/components/entities/wordstatplaces/CreateDialog.vue';
    import UpdateWordstatplace from '@/components/entities/wordstatplaces/UpdateDialog.vue';
    import DeleteWordstatplace from '@/components/entities/wordstatplaces/DeleteDialog.vue';
    import projectHandlers from '@/mixins/project';

    export default {
        name: 'ProjectWordStatplaces',
        props: ['data'],
        mixins: [projectHandlers],
        components: {
            'wordstatplace-create': CreateWordstatplace,
            'wordstatplace-update': UpdateWordstatplace,
            'wordstatplace-delete': DeleteWordstatplace,
        },
        data() {
            return {
                visibility: {
                    update: false,
                    create: false,
                    delete: false,
                    info: false,
                    state: false,
                    factors: false
                },
                project: this.data,
                indicator: {
                    list: false,
                    sync: false,
                    updates: false
                },
                wordstatplaces: [],
                cursorWordstatplace: {
                    project_id: this.data.project_id,
                    vertical_id: this.data.vertical_id,
                    phrases: [],
                    geo_id: []
                },
            }
        },
        computed: {
            wordstatplaceCreateAllowed() {
                return ['X', 'U'].includes(this.project.mode_statplaces)
            },
            wordstatplaceDeleteAllowed() {
                return ['X', 'U'].includes(this.project.mode_statplaces)
            },
            factorsAllowed() {
                return ['X', 'U'].includes(this.project.mode_statplaces) && ['X', 'U'].includes(this.project.mode_persons)
            },
        },
        watch: {
            data(value) {
                if (value) {
                    this.project = value;
                    this.getProjectWordstatpalces()
                }
            }
        },
        methods: {
            getProjectWordstatpalces() {
                this.getProjectPropertyPromise('wordstatplaces').then((r) => {
                    let response = r.body;
                    this.indicator.list = false;
                    if (response.result) {
                        this.wordstatplaces = response.data;
                    } else {
                        console.log('error fetch project wordstatplaces', response.data)
                    }
                });
            },
            downloadStat(s) {
                const params = {
                    id: s.id
                };
                this.$http.post(this.$store.getters.endpoint + '/db/fetch_wordstat', params, {
                    headers: {...this.$store.state.restrictedHeaders, ...{'Content-Type': 'application/json;charset=UTF-8'}}
                }).then(r => {
                    let response = r.body;
                    console.log(response)
                }).catch(e => {
                    console.log(e)
                }).finally(() => {
                    this.getProjectWordstatpalces();
                })
            },
            castWordStatPlace(s) {
                if (s) {
                    this.cursorWordstatplace = {
                        id: s.id,
                        project_id: s.project_id,
                        vertical_id: s.vertical_id,
                        user_login: s.user_login,
                        phrases: s.phrases.map(el => {
                            return {
                                text: el
                            }
                        }),
                        geo_id: s.geo_id.map(el => {
                            return el.region_id;
                        })
                    };
                } else {
                    this.cursorWordstatplace = {
                        project_id: this.data.project_id,
                        vertical_id: this.data.vertical_id,
                        phrases: [],
                        geo_id: []
                    }
                }

            }
        },
        mounted() {
            this.getProjectWordstatpalces();
        }

    }
</script>
